import { render, staticRenderFns } from "./RulesFilter.vue?vue&type=template&id=3241b7c7"
import script from "./RulesFilter.vue?vue&type=script&lang=js"
export * from "./RulesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports